import * as types from './actionTypes'

export const sendSMSAction = mobile => ({
  type: types.SEND_SMS,
  payload: mobile,
})

export const confirmSMSAction = (mobile, code) => ({
  type: types.CONFIRM_SMS,
  payload: { code, mobile },
})
